import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';

// Visible, authenticated app use is separate from email-link attribution.
export default function LifecycleAppActivity() {
  const { userData } = useAppContext();
  const { pathname } = useLocation();
  const activity = useRef({userId: null, lastReported: 0, inFlight: false});
  useEffect(() => {
    if (!userData?.user_id) return;
    if (activity.current.userId !== userData.user_id) activity.current = {userId: userData.user_id, lastReported: 0, inFlight: false};
    const customerRoute = ['/chat-workspace', '/chat', '/chat-network', '/account', '/agent-tasks', '/plan-selection'].includes(pathname) || pathname.startsWith('/x/');
    if (!customerRoute) return;
    const state = activity.current;
    const report = async () => {
      if (document.visibilityState !== 'visible' || state.inFlight || Date.now() - state.lastReported < 15 * 60 * 1000) return;
      state.inFlight = true;
      try {
        const response = await fetch('/lifecycle-outreach/activity', { method: 'POST', credentials: 'same-origin' });
        if (response.ok) state.lastReported = Date.now();
      } finally { state.inFlight = false; }
    };
    const safelyReport = () => { report().catch(() => {}); };
    safelyReport();
    document.addEventListener('visibilitychange', safelyReport);
    window.addEventListener('focus', safelyReport);
    return () => {
      document.removeEventListener('visibilitychange', safelyReport);
      window.removeEventListener('focus', safelyReport);
    };
  }, [userData?.user_id, pathname]);
  return null;
}
